module.exports = __webpack_public_path__ + "static/media/subOutlook4.a580b5e6.png";